import { defineMessages } from "react-intl";

const messages = defineMessages({
    type: {
        id: "meta.type",
    },
    opus: {
        id: "meta.opus",
    },
    folksong: {
        id: "meta.folksong",
    },
    composer: {
        id: "meta.composer",
    },
    genre: {
        id: "meta.genre",
    },
    country: {
        id: "meta.country",
    },
    tempo: {
        id: "meta.tempo",
    },
    isLyrics: {
        id: "meta.isLyrics",
    },
    language: {
        id: "meta.language",
    },
    isAccompaniment: {
        id: "meta.isAccompaniment",
    },
    isCanon: {
        id: "meta.isCanon",
    },
    folksongClass: {
        id: "meta.folksongClass",
    },
    exerciseType: {
        id: "meta.exerciseType",
    },
    folksongTempo: {
        id: "meta.folksongTempo",
    },
    level: {
        id: "meta.level",
    },
    taskTypes: {
        id: "browse.teaching.taskTypes",
    },
    isChildrenSong: {
        id: "meta.opus.isChildrenSong",
    },
    isChurchMusic: {
        id: "meta.opus.isChurchMusic",
    },
    levelTooltip: {
        id: "meta.teaching.level.tooltip",
    },
    experience: {
        id: "plan.experience",
    },
    era: {
        id: "meta.era",
    },
});

export default messages;
